package com.sweetlime.bingeamigo.presentation.features.moviedetail

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.Movie

data class MovieDetailScreen(
    val movieId: Int,
    val movieTitle: String,
    val movieOverview: String = "",
    val movieAdult: Boolean = false,
    val movieBackdropPath: String? = null,
    val movieOriginalLanguage: String = "",
    val movieOriginalTitle: String = "",
    val moviePopularity: Double = 0.0,
    val moviePosterPath: String? = null,
    val movieReleaseDate: String = "",
    val movieVideo: Boolean = false,
    val movieVoteAverage: Double = 0.0,
    val movieVoteCount: Int = 0
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val movie = Movie(
            id = movieId,
            title = movieTitle,
            overview = movieOverview,
            adult = movieAdult,
            backdropPath = movieBackdropPath,
            originalLanguage = movieOriginalLanguage,
            originalTitle = movieOriginalTitle,
            popularity = moviePopularity,
            posterPath = moviePosterPath,
            releaseDate = movieReleaseDate,
            video = movieVideo,
            voteAverage = movieVoteAverage,
            voteCount = movieVoteCount
        )
        MovieDetailContent(
            movie = movie,
            onBackClick = { navigator.pop() }
        )
    }
}

fun MovieDetailScreen(movie: Movie) = MovieDetailScreen(
    movieId = movie.id,
    movieTitle = movie.title,
    movieOverview = movie.overview,
    movieAdult = movie.adult,
    movieBackdropPath = movie.backdropPath,
    movieOriginalLanguage = movie.originalLanguage,
    movieOriginalTitle = movie.originalTitle,
    moviePopularity = movie.popularity,
    moviePosterPath = movie.posterPath,
    movieReleaseDate = movie.releaseDate,
    movieVideo = movie.video,
    movieVoteAverage = movie.voteAverage,
    movieVoteCount = movie.voteCount
)